import clsx from "clsx"
import { Tooltip } from "react-tooltip"

import { useAsideMenu } from "hooks/useAsideMenu"
import { useNavigate } from "react-router-dom"
import { DEFAULT_SIZE } from "utils/icons"

type ButtonIconLinkProps = {
	id: number
	Icon: React.ComponentType<{ className: string; size: number }>
	isVisible?: boolean
	className?: string
	path?: string
	label: string
	dataCy: string
	external?: boolean
}

export const ButtonIconLink = ({
	id,
	Icon,
	isVisible,
	path,
	label,
	dataCy,
	external,
}: ButtonIconLinkProps) => {
	const { currentActiveAsideMenu, setActiveAsideMenu } = useAsideMenu()
	const navigate = useNavigate()
	const handleNavigateTo = () => {
		if (external) {
			window.open(path)
		} else {
			setActiveAsideMenu(id)
			if (path) navigate(path)
		}
	}

	if (!isVisible) return <></>

	return (
		<div className={"flex justify-center my-2"}>
			<button
				className={clsx("py-2.5 c-aside__subNav-link", {
					"is-active": currentActiveAsideMenu === id,
				})}
				onClick={handleNavigateTo}
				type="button"
				data-tooltip-content={label}
				data-tooltip-id="menu-tooltip"
				data-cy={dataCy}
			>
				<Icon className="" size={DEFAULT_SIZE} />
			</button>
			<Tooltip id="menu-tooltip" className="menu-tooltip" place="right" />
		</div>
	)
}
